import React, { useState } from 'react';
import Tab from '@mui/material/Tab';
import ScheduleTab from './ScheduleTab';
import ScoresTab from './scoresTab/ScoresTab';
import StudentProfileTab from './StudentProfileTab';
import LiveCourseDataTab from './LiveCourseDataTab';
import SpedNotesTab from './spedNotesTab/SpedNotesTab';
import DashboardPasswordTab from './DashboardPasswordTab';
import { StickyTab, TabContainer } from 'components/Ui/styled';
import TabPanel, { a11yProps } from 'components/Common/TabPanel/TabPanel';
import { usePermissionCustomHook } from 'layouts/users/userPermissions/utils/permissionsUtils';

const StudentProfileTabs = () => {
  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const canAccessStudentTestingData = usePermissionCustomHook(
    'CAN_ACCESS_STUDENT_TESTING_DATA'
  );

  const canViewStudentProfile = usePermissionCustomHook(
    'CAN_VIEW_STUDENT_PROFILE'
  );
  const canAccessSpedNotes = usePermissionCustomHook('CAN_ACCESS_SPED_NOTES');

  const tabsConfig = [
    { label: 'Student Profile', component: <StudentProfileTab /> },
    { label: 'Schedule', component: <ScheduleTab /> },
    {
      label: 'Testing Data',
      component: <ScoresTab />,
      permission: canAccessStudentTestingData,
    },
    {
      label: 'Live Course Data',
      component: <LiveCourseDataTab />,
      permission: canViewStudentProfile,
    },
    { label: 'Dashboard Password', component: <DashboardPasswordTab /> },
    {
      label: 'SPED Notes',
      component: <SpedNotesTab />,
      permission: canAccessSpedNotes,
    },
  ];

  const studentProfileTabs = tabsConfig?.filter(
    (tab) => tab.permission !== false
  );

  return (
    <TabContainer>
      <StickyTab
        value={value}
        onChange={handleTabChange}
        aria-label="studentProfileTabs"
      >
        {studentProfileTabs?.map((tab, index) => (
          <Tab key={tab.label} label={tab.label} {...a11yProps(index)} />
        ))}
      </StickyTab>

      {studentProfileTabs?.map((tab, index) => (
        <TabPanel key={tab.label} value={value} index={index}>
          {tab.component}
        </TabPanel>
      ))}
    </TabContainer>
  );
};

export default StudentProfileTabs;
